import { Route, Routes, useLocation } from "react-router-dom";
import { WalletContext } from "./components/WalletContext";
import { WalletCollectionPage } from "./pages/Collection";
import { CollectionDetailPage } from "./pages/CollectionDetail";
import { LandingPage } from "./pages/Landing";
import TrendingPage from "./pages/Trending";
import { PageRoutes } from "./utils/constants";
import { useEffect } from "react";
import ReactGA from "react-ga4";
import { CollectionMainDetailPage } from "./pages/CollectionMainDetail";

const TRACKING_ID = "G-RXMG0L24KM"; // OUR_TRACKING_ID

//wallet adapter custom ui css
require("@solana/wallet-adapter-react-ui/styles.css");

const App = () => {
	ReactGA.initialize(TRACKING_ID);
	const location = useLocation();

	useEffect(() => {
		ReactGA.set({ page: location.pathname });
		ReactGA.pageview(location.pathname);
	}, [location]);

	return (
		<WalletContext>
			<Routes>
				<Route path={PageRoutes.Details} element={<CollectionDetailPage />} />
				<Route path={PageRoutes.Trending} element={<TrendingPage />} />
				<Route
					path={PageRoutes.CollectionDetails}
					element={<CollectionMainDetailPage />}
				/>
				<Route
					path={PageRoutes.Collection}
					element={<WalletCollectionPage />}
				/>
				<Route path={PageRoutes.Home} element={<LandingPage />} />
			</Routes>
		</WalletContext>
	);
};

export default App;
